/**
 * Global, cross-cutting behaviour shared by every page: progressive-
 * enhancement flag, scroll-reveal engine, and small utilities section-level
 * scripts (loaded via {% javascript %} tags) rely on.
 */
(function () {
  document.documentElement.classList.add('js-ready');

  // A broken secondary image must never make a product card disappear on hover.
  document.querySelectorAll('.product-card--has-secondary-image .product-card__image--secondary').forEach(function (image) {
    function disableSecondaryImage() {
      var card = image.closest('.product-card--has-secondary-image');
      if (card) card.classList.remove('product-card--has-secondary-image');
      image.remove();
    }

    image.addEventListener('error', disableSecondaryImage);
    if (image.complete && image.naturalWidth === 0) disableSecondaryImage();
  });

  // ---- Scroll reveal --------------------------------------------------
  var revealTargets = document.querySelectorAll('[data-scroll-reveal]');
  if (revealTargets.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    revealTargets.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index % 6, 5) * 60 + 'ms';
      revealObserver.observe(el);
    });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---- Shared utilities -------------------------------------------------
  window.theme = window.theme || {};

  window.theme.debounce = function (fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () { fn.apply(context, args); }, wait);
    };
  };

  window.theme.trapFocus = function (container, initialFocusEl) {
    var focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function onKeydown(event) {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    (initialFocusEl || first).focus();

    return function () {
      container.removeEventListener('keydown', onKeydown);
    };
  };

  window.theme.announce = function (message) {
    var region = document.getElementById('a11y-live-region');
    if (region) region.textContent = message;
  };

  // ---- Quantity steppers ----------------------------------------------
  // The cart drawer owns its own AJAX quantity flow in cart-drawer.js. Keep
  // these controls delegated here for product and full-cart pages, where the
  // same snippet is rendered without a page-specific script.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-increase], [data-quantity-decrease]');
    if (!button || button.closest('[data-cart-drawer-body]')) return;

    var controls = button.closest('.quantity-input');
    if (!controls) return;

    var fieldId = button.getAttribute('aria-controls');
    var field = fieldId ? document.getElementById(fieldId) : null;
    if (!field) field = controls.querySelector('[data-quantity-field]');
    if (!field) return;

    event.preventDefault();

    var min = parseInt(field.getAttribute('min'), 10);
    var max = parseInt(field.getAttribute('max'), 10);
    var current = parseInt(field.value, 10);
    if (isNaN(min)) min = 1;
    if (isNaN(current)) current = min;

    var next = button.matches('[data-quantity-increase]') ? current + 1 : current - 1;
    next = Math.max(min, next);
    if (!isNaN(max)) next = Math.min(max, next);

    field.value = String(next);
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
